import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ClusterRejectionRequest } from '../../types/cluster'

const { CLUSTERS_API_URL } = CONSTANT

const rejectCluster = async (
	clusterRejection: ClusterRejectionRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${CLUSTERS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'REJECT'
		},
		body: JSON.stringify(clusterRejection)
	})
	return response.json()
}

export default rejectCluster
